import VideosList from './videos-list';
import { map } from '../../../map/map.desktop';
import AutoBindComponents from '../../../helpers/auto-bind-components';

export default class VideosListDesktop extends VideosList {
    constructor(...args) {
        super(...args);

        this._map = map;
    }

    _bindNewVideoCard() {
        // Reparse and Store ImageCursor Elements
        
        new AutoBindComponents('ct--video-card', 'videoCard');
	}

    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}



// WEBPACK FOOTER //
// ./src/js/pages/videos/list/videos-list.desktop.js